var map = {
	"./crash1.png": 7993,
	"./crash10.png": 2797,
	"./crash2.png": 7026,
	"./crash3.png": 1851,
	"./crash4.png": 7988,
	"./crash5.png": 1885,
	"./crash6.png": 7910,
	"./crash7.png": 4847,
	"./crash8.png": 2619,
	"./crash9.png": 5217
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7215;